var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-topic__pendant"},[_c('pendant',{attrs:{"icon-url":_vm.iconUrl,"show-tooltip":false},on:{"click":function($event){return _vm.$emit('click')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }